var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    [
      _c("search-toolbar", {
        attrs: {
          resultType: "clubs",
          from: _vm.from,
          to: _vm.to,
          sortFields: _vm.sortFields,
          totalCount: _vm.totalCount
        },
        on: {
          search: function($event) {
            return _vm.getFacilities($event)
          },
          clearsearch: function($event) {
            return _vm.clearSearch($event)
          },
          changeSort: function($event) {
            return _vm.changeSort($event)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "md-layout", attrs: { id: "facilitylist" } },
        _vm._l(_vm.facilities, function(facility, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass:
                "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
            },
            [
              _c(
                "md-list",
                { staticClass: "md-double-line" },
                [
                  _c(
                    "md-list-item",
                    {
                      on: {
                        click: function($event) {
                          return _vm.selectfacility(facility)
                        }
                      }
                    },
                    [
                      facility.logoUrl
                        ? _c("img", {
                            staticClass: "facility-logo",
                            attrs: {
                              src: facility.logoUrl,
                              alt: facility.name
                            },
                            on: { error: _vm.onError }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "md-list-item-text" }, [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(_vm.setName(facility))
                          }
                        }),
                        _vm._v(" "),
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(_vm.setCity(facility))
                          }
                        })
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3176496c", { render: render, staticRenderFns: staticRenderFns })
  }
}